export default __webpack_public_path__ + "static/bidra-i-figma5-619eaa03fde5101a19a6b49c331f9140.png";